type BasePackageType = "5g" | "5g-tv" | "5g-ready" | "5g-ready-tv" | "5g-ready-cabin" | "5g-cabin" | "5g-cabin-tv";
export type DiyPackageTypes = `${BasePackageType}-diy`;
export type PackageType = "4g" | BasePackageType | DiyPackageTypes;

export const packageTypes: BasePackageType[] = [
    "5g",
    "5g-tv",
    "5g-ready",
    "5g-ready-tv",
    "5g-ready-cabin",
    "5g-cabin",
    "5g-cabin-tv",
];

export const diyPackageTypes: DiyPackageTypes[] = packageTypes.map((p) => `${p}-diy` as DiyPackageTypes);
